import Component from 'component';
import { assert } from 'utils';
const formatDate = (date) => {
    return date.toISOString().split('T')[0];
};
export const TOGGLER_ATTR = 'data-display-toggle';
export const SEND_ON_INPUT_ATTR = 'data-send-on-field';
const SCHEDULE_LIMIT = 89;
customElements.define('x-product-form-gift-card', class extends Component {
    constructor() {
        super();
        this.$element.fieldset = this.querySelector('[data-product-form-gift-card-element="fieldset"]');
        this.$element.offset = this.querySelector('[data-product-form-gift-card-element="offset"]');
    }
    inited = false;
    render() {
        assert(this.$element.fieldset, `Fieldset is not defined`);
        this.on(this, 'change', (e) => {
            const target = e.target;
            if (!target.hasAttribute(TOGGLER_ATTR)) {
                return;
            }
            this.$element.fieldset.toggleAttribute('disabled', !target.checked);
            if (this.inited) {
                return;
            }
            const sendOnInput = this.querySelector(`[${SEND_ON_INPUT_ATTR}]`);
            assert(sendOnInput, `Send-on field is not defined`);
            sendOnInput.setAttribute('min', formatDate(new Date()));
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + SCHEDULE_LIMIT);
            sendOnInput.setAttribute('max', formatDate(maxDate));
            assert(this.$element.offset, `Offset field is not defined`);
            this.$element.offset.value = new Date().getTimezoneOffset().toString();
            this.inited = true;
        });
    }
});
